import { ShowcaseProjectMediaItem } from 'data/v3/showcases';

export const idExtractor = ({ id }: ShowcaseProjectMediaItem) => id;
